import { render, staticRenderFns } from "./ContactCapture.vue?vue&type=template&id=20457798&scoped=true&"
import script from "./ContactCapture.vue?vue&type=script&lang=js&"
export * from "./ContactCapture.vue?vue&type=script&lang=js&"
import style0 from "./ContactCapture.vue?vue&type=style&index=0&id=20457798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20457798",
  null
  
)

export default component.exports